// extracted by mini-css-extract-plugin
export var content = "_dm-3";
export var list = "_dm-4";
export var settingsContent = "_dm-7";
export var settingsPanel = "_dm-8";
export var state = "_dm-6";
export var triggerBadge = "_dm-2";
export var triggerButton = "_dm-1";
export var triggerShell = "_dm-0";
export var unreadDot = "_dm-5";